import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';

import Loading from '../../common/Loading';
import Error from '../../common/Error';

import ReelTypeImage from '../../../resources/ReelTypeDimensions.png';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function LoadListListItemReelTypeDetail(props){
    //console.debug("RTS Break LoadListListItemReelTypeDetail");

    const {curFilter, user, sessionCustomer, userAuthToken, apiRoot, userLogOut} = useSessionContext();
        
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    
    const [data, setData] = useState([]);
    

    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/ReelTypes/GetReelTypeById/" + pFilter;
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status === 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token, userLogOut]); 


    useEffect(() => {
            fetchData(props.idGuid);
    }, [props, user, sessionCustomer, curFilter, fetchData]); 


    if(hasError){
        return(
            <Error />
        );
    };


    if(isLoading){
        return(
            <Loading />
        );
    };

    return (
    <>
        <Grid container>
            <Grid item xs={12} md={6}>
                <Box sx={{display:'flex', alignItems:'center'}}>
                    <Typography variant="h6">{data.desc}</Typography>
                    <Typography variant="caption" sx={{ml:1}}>({data.idSap})</Typography>
                </Box>
                <Box sx={{display:'flex'}}>
                    <Typography variant="body2" sx={{fontWeight:'bold'}}>Material:</Typography>
                    <Typography variant="body2" sx={{ml:'2px'}}>{data.material}</Typography>
                </Box>
                <Box sx={{display:'flex'}}>
                    <Typography variant="body2" sx={{fontWeight:'bold'}}>Aluminum Assoc. Id:</Typography>
                    <Typography variant="body2" sx={{ml:'2px'}}>{data.alumAssoc}</Typography>
                </Box>
                <Typography variant="h6" sx={{mt:1}}>Dimensions (inches)</Typography>
                <Box sx={{display:'flex'}}>
                    <Typography variant="body2" sx={{fontWeight:'bold'}}>Flange Size:</Typography>
                    <Typography variant="body2" sx={{ml:'2px'}}>{data.flangeSize}</Typography>
                </Box>
                <Box sx={{display:'flex'}}>
                    <Typography variant="body2" sx={{fontWeight:'bold'}}>Traverse Size:</Typography>
                    <Typography variant="body2" sx={{ml:'2px'}}>{data.traverseSize}</Typography>
                </Box>
                <Box sx={{display:'flex'}}>
                    <Typography variant="body2" sx={{fontWeight:'bold'}}>Drum Size:</Typography>
                    <Typography variant="body2" sx={{ml:'2px'}}>{data.drumSize}</Typography>
                </Box>
                <Box sx={{display:'flex'}}>
                    <Typography variant="body2" sx={{fontWeight:'bold'}}>Max Overall Width:</Typography>
                    <Typography variant="body2" sx={{ml:'2px'}}>{data.maxOverallWidth}</Typography>
                </Box>
                <Box sx={{display:'flex'}}>
                    <Typography variant="body2" sx={{fontWeight:'bold'}}>Arbor Hole Size:</Typography>
                    <Typography variant="body2" sx={{ml:'2px'}}>{data.arborHoleSize}</Typography>
                </Box>
                <Typography variant="h6" sx={{mt:1}}>Weights (lbs)</Typography>
                <Box sx={{display:'flex'}}>
                    <Typography variant="body2" sx={{fontWeight:'bold'}}>Weight Capacity:</Typography>
                    <Typography variant="body2" sx={{ml:'2px'}}>{data.weightCapacity!=null?data.weightCapacity.toLocaleString():''}</Typography>
                </Box>
                <Box sx={{display:'flex'}}>
                    <Typography variant="body2" sx={{fontWeight:'bold'}}>Weight:</Typography>
                    <Typography variant="body2" sx={{ml:'2px'}}>{data.approxWeight!=null?data.approxWeight.toLocaleString():''}</Typography>
                </Box>
            </Grid>
            <Grid item xs={12} md={6} sx={{mt:{xs:2, md:0}}}>
                <CardMedia
                    component="img"
                    image={ReelTypeImage}
                    onLoad={() => console.log("this is loading")}
                    onError={() => console.log("this is error")}
                    alt="This is a sample image"
                    sx={{
                    maxWidth: {
                        xs: "100%",
                        sm: "500px",
                    },
                    objectFit: "cover",
                    }}
                />
            </Grid>
        </Grid>
    </>
    )
}

